import { mapValues, noop } from '../libraries/lodash'
import { withDefaults } from '../helpers/lodash'
const consoleSupported = !!console && !!console.log.bind

const methods = ['log', 'time', 'timeEnd', 'error', 'warn']
let debug = withDefaults(methods, noop)

if (process.env.NODE_ENV !== 'production' && consoleSupported) {
  debug = mapValues(debug, (v, k) => console[k].bind(console))
}

export default debug
